<template>
    <div style="width:100%;height:100%">
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white;">
                <el-button type="primary" size="mini" @click="showitems">{{ $t('getapi[438]') }}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{ $t('getapi[4411]') }}</el-button>
                
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 10px"
                    >
                    <el-button slot="trigger" size="mini" type="primary">{{ $t('getapi[4410]') }}</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{ $t('getapi[506]') }}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{ $t('getapi[507]') }}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <!-- <div slot="header" class="clearfix"><span>计划相关设置</span></div> -->
            <vxe-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    resizable
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    tab-click="selectInfo(0)"
                    @checkbox-change="handleSelectionChange"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <vxe-table-column type="checkbox" align="center"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="Exclusively_id" title="ID" v-if="false"></vxe-table-column>
                <vxe-table-column field="DataStatus" :title="$t('getapi[504]')" width="80">
                    <template scope="scope">
                        <span>{{scope.row.DataStatus | lanchange}}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')"  width="150"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width="80"></vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'planning_CODE' ? 'check' : ''"
                                 field="planning_CODE" :title="$t('getapi[221]')"  width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.planning_CODE"
                                   v-if="editPlan == 'planning_CODE'">
                            <el-option v-for="item in planning_CODE" :key="item.value" :title="item.title"
                                       :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'planning_CODE'">{{ scope.row.planning_CODE }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'LEAST_PURCH_BATCH' ? 'check' : ''"
                                 field="LEAST_PURCH_BATCH" :title="$t('getapi[152]')" align="right"  width="80">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.LEAST_PURCH_BATCH"
                                  v-if="editPlan == 'LEAST_PURCH_BATCH'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'LEAST_PURCH_BATCH'">{{ scope.row.LEAST_PURCH_BATCH }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'STOCK_LOWERLIMIT' ? 'check' : ''"
                                 field="STOCK_LOWERLIMIT" :title="$t('getapi[2548]')" align="right"  width="80">
                    <template scope="scope" >
                        <el-input class-name="check" size="small" v-model="scope.row.STOCK_LOWERLIMIT"
                                  v-if="editPlan == 'STOCK_LOWERLIMIT'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'STOCK_LOWERLIMIT'">{{ scope.row.STOCK_LOWERLIMIT|tofixed4 }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'PURCHASE_LEADTIME' ? 'check' : ''"
                                 field="PURCHASE_LEADTIME" :title="$t('getapi[158]')" align="right"  width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.PURCHASE_LEADTIME"
                                  v-if="editPlan == 'PURCHASE_LEADTIME'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'PURCHASE_LEADTIME'">{{ scope.row.PURCHASE_LEADTIME }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'Produce_LEADTIME' ? 'check' : ''"
                                 field="Produce_LEADTIME" :title="$t('getapi[161]')" align="right"  width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.Produce_LEADTIME"
                                  v-if="editPlan == 'Produce_LEADTIME'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'Produce_LEADTIME'">{{ scope.row.Produce_LEADTIME }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'MergeDays' ? 'check' : ''"
                                 field="MergeDays" :title="$t('getapi[153]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.MergeDays"
                                  v-if="editPlan == 'MergeDays'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'MergeDays'">{{ scope.row.MergeDays }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'Standard_BATCH' ? 'check' : ''"
                                 field="Standard_BATCH" :title="$t('getapi[159]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.Standard_BATCH"
                                  v-if="editPlan == 'Standard_BATCH'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'Standard_BATCH'">{{ scope.row.Standard_BATCH }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'Products' ? 'check' : ''"
                                 field="Products" :title="$t('getapi[145]')" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.Products"
                                  v-if="editPlan == 'Products'" ></el-input>
                        <span v-if="editPlan != 'Products'">{{ scope.row.Products }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'PLANNER_NAME' ? 'check' : ''"
                                 field="PLANNER_NAME" :title="$t('getapi[163]')" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.PLANNER_NAME"
                                  v-if="editPlan == 'PLANNER_NAME'"></el-input>
                        <span v-if="editPlan != 'PLANNER_NAME'">{{ scope.row.PLANNER_NAME }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'package_qty' ? 'check' : ''"
                                 field="package_qty" :title="$t('getapi[164]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.package_qty"
                                  v-if="editPlan == 'package_qty'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'package_qty'">{{ scope.row.package_qty }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'STOCK_UPPERLIMIT' ? 'check' : ''"
                                 field="STOCK_UPPERLIMIT" :title="$t('getapi[156]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.STOCK_UPPERLIMIT"
                                  v-if="editPlan == 'STOCK_UPPERLIMIT'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'STOCK_UPPERLIMIT'">{{ scope.row.STOCK_UPPERLIMIT }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'saledemandflag' ? 'check' : ''"
                                 field="saledemandflag" :title="$t('getapi[166]')" width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.saledemandflag"
                                   v-if="editPlan == 'saledemandflag'">
                            <el-option v-for="item in saledemandflag" :key="item.value" :title="item.title"
                                       :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'saledemandflag'">{{ scope.row.saledemandflag }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'CYCLE_CHECK_INTERVAL' ? 'check' : ''"
                                 field="CYCLE_CHECK_INTERVAL" :title="$t('getapi[151]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.CYCLE_CHECK_INTERVAL"
                                  v-if="editPlan == 'CYCLE_CHECK_INTERVAL'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'CYCLE_CHECK_INTERVAL'">{{ scope.row.CYCLE_CHECK_INTERVAL }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'REQUIRE_PERIOD' ? 'check' : ''"
                                 field="REQUIRE_PERIOD" :title="$t('getapi[154]')" align="right" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.REQUIRE_PERIOD"
                                  v-if="editPlan == 'REQUIRE_PERIOD'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'REQUIRE_PERIOD'">{{ scope.row.REQUIRE_PERIOD }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'PLANNING_PERIOD' ? 'check' : ''"
                                 field="PLANNING_PERIOD" :title="$t('getapi[155]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.PLANNING_PERIOD"
                                  v-if="editPlan == 'PLANNING_PERIOD'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'PLANNING_PERIOD'">{{ scope.row.PLANNING_PERIOD }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'Year_BATCH' ? 'check' : ''"
                                 field="Year_BATCH" :title="$t('getapi[160]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.Year_BATCH"
                                  v-if="editPlan == 'Year_BATCH'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'Year_BATCH'">{{ scope.row.Year_BATCH }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'DigitScale' ? 'check' : ''"
                                 field="DigitScale" :title="$t('getapi[165]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.DigitScale"
                                  v-if="editPlan == 'DigitScale'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'DigitScale'">{{ scope.row.DigitScale }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'QC_Leadtime' ? 'check' : ''"
                                 field="QC_Leadtime" :title="$t('getapi[6006]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.QC_Leadtime"
                                  v-if="editPlan == 'QC_Leadtime'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'QC_Leadtime'">{{ scope.row.QC_Leadtime }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'So_Issue_control' ? 'check' : ''"
                                 field="So_Issue_control" :title="$t('getapi[6007]')" width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.So_Issue_control"
                                   v-if="editPlan == 'So_Issue_control'">
                            <el-option v-for="item in So_Issue_control" :key="item.value" :title="item.title"
                                       :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'So_Issue_control'">{{ scope.row.So_Issue_control }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'safe_days' ? 'check' : ''"
                                 field="safe_days" :title="$t('getapi[6008]')" align="right" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.safe_days"
                                  v-if="editPlan == 'safe_days'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'safe_days'">{{ scope.row.safe_days }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'STOCK_LOWEST' ? 'check' : ''"
                                 field="STOCK_LOWEST" :title="$t('getapi[6009]')" align="right" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.STOCK_LOWEST"
                                  v-if="editPlan == 'STOCK_LOWEST'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'STOCK_LOWEST'">{{ scope.row.STOCK_LOWEST }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'Method' ? 'check' : ''"
                                  field="Method" :title="$t('getapi[6419]')" width="100">
                    <template scope="scope">
                        <el-select filterable v-model="scope.row.Method"  size="mini" v-if="editPlan == 'Method'">
                            <el-option :label="$t('getapi[7998]')" value="发料量"></el-option>
                            <el-option label="MRP" value="MRP"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'Method'">{{ scope.row.Method }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'Routing_Sequence' ? 'check' : ''"
                                  field="Routing_Sequence" :title="$t('getapi[2326]')" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.Routing_Sequence"
                                  v-if="editPlan == 'Routing_Sequence'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'Routing_Sequence'">{{ scope.row.Routing_Sequence }}</span>
                    </template>
                </vxe-table-column>               

                <vxe-table-column :class-name="editPlan == 'MP_Flag' ? 'check' : ''"
                                 field="MP_Flag" :title="$t('getapi[134]')"  width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.MP_Flag"
                                   v-if="editPlan == 'MP_Flag'">
                            <el-option v-for="item in mp_flag" :key="item.value" :title="item.title"
                                       :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'MP_Flag'">{{ scope.row.MP_Flag }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'mrp_fa_flag' ? 'check' : ''"
                                  field="mrp_fa_flag" :title="$t('getapi[12583]')"  width="80">
                    <template scope="scope">
                        <el-checkbox  v-model="scope.row.mrp_fa_flag" :true-label=1
                                      :false-label=0 v-if="editPlan == 'mrp_fa_flag'"></el-checkbox>
                        <el-checkbox  v-model="scope.row.mrp_fa_flag" :true-label=1
                                      :false-label=0 v-if="editPlan != 'mrp_fa_flag'" :disabled="true"></el-checkbox>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'prefix' ? 'check' : ''"
                                  field="prefix" :title="$t('getapi[6052]')" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.prefix"
                                  v-if="editPlan == 'prefix'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'prefix'">{{ scope.row.prefix }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'suffix' ? 'check' : ''"
                                  field="suffix" :title="$t('getapi[7127]')" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.suffix"
                                  v-if="editPlan == 'suffix'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'suffix'">{{ scope.row.suffix }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'digit' ? 'check' : ''"
                                  field="digit" :title="$t('getapi[12579]')" width="80" align="right">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.digit"
                                  v-if="editPlan == 'digit'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'digit'">{{ scope.row.digit }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'leadtime_manflag' ? 'check' : ''"
                                 field="leadtime_manflag" :title="$t('getapi[8059]')" width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.leadtime_manflag"
                                   v-if="editPlan == 'leadtime_manflag'">
                            <el-option v-for="item in leadtime_manflag" 
                                :key="item.value" :title="item.title" :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'leadtime_manflag'">{{ scope.row.leadtime_manflag }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'print_flag' ? 'check' : ''"
                                  field="print_flag" :title="$t('getapi[12720]')"  width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.print_flag"
                                   v-if="editPlan == 'print_flag'">
                            <el-option v-for="item in printflagarr"
                                       :key="item.value" :title="item.title" :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'print_flag'">{{ scope.row.print_flag }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'cus_draw_version' ? 'check' : ''"
                                  field="cus_draw_version" :title="$t('getapi[12962]')" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.cus_draw_version"
                                  v-if="editPlan == 'cus_draw_version'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'cus_draw_version'">{{ scope.row.cus_draw_version }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'cusitem_name' ? 'check' : ''"
                                  field="cusitem_name" :title="$t('getapi[12963]')" width="80">
                    <template scope="scope">
                        <el-input size="small" v-model="scope.row.cusitem_name"
                                  v-if="editPlan == 'cusitem_name'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'cusitem_name'">{{ scope.row.cusitem_name }}</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </el-card>
        <!--<pickpart :isVisible="itevisible" @getitembom="getitembom" ref="input"></pickpart>-->
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Eng/Parts/PlanGetPart'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'planningdatasetting',
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 178, // 主表高度
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [
                    {
                        value: '0',
                        label: this.$t('getapi[852]')//'未选择'
                    },
                    {
                        value: 'planning_CODE',
                        label: this.$t('getapi[221]')//'计划类型'
                    },
                    {
                        value: 'LEAST_PURCH_BATCH',
                        label: this.$t('getapi[152]')//'最小订购批量'
                    },
                    {
                        value: 'STOCK_LOWERLIMIT',
                        label: this.$t('getapi[2548]')//'安全库存'
                    },
                    {
                        value: 'PURCHASE_LEADTIME',
                        label: this.$t('getapi[158]')//'采购提前期'
                    },
                    {
                        value: 'Produce_LEADTIME',
                        label: this.$t('getapi[161]')//'生产提前期'
                    },
                    {
                        value: 'MergeDays',
                        label: this.$t('getapi[153]')//'合并天数'
                    },
                    {
                        value: 'Standard_BATCH',
                        label: this.$t('getapi[159]')//'标准批量'
                    },
                    {
                        value: 'Products',
                        label: this.$t('getapi[145]')//'所属产品'
                    },
                    {
                        value: 'PLANNER_NAME',
                        label: this.$t('getapi[163]')//'计划员'
                    },
                    {
                        value: 'package_qty',
                        label: this.$t('getapi[164]')//'订单增量'
                    },
                    {
                        value: 'STOCK_UPPERLIMIT',
                        label: this.$t('getapi[156]')//'库存上限'
                    },
                    {
                        value: 'saledemandflag',
                        label: this.$t('getapi[166]')//'客户订单限制'
                    },
                    {
                        value: 'CYCLE_CHECK_INTERVAL',
                        label: this.$t('getapi[151]')//'循环盘点间隔'
                    },
                    {
                        value: 'REQUIRE_PERIOD',
                        label: this.$t('getapi[154]')//'需求时界'
                    },
                    {
                        value: 'PLANNING_PERIOD',
                        label: this.$t('getapi[155]')//'计划时界'
                    },
                    {
                        value: 'Year_BATCH',
                        label: this.$t('getapi[160]')//'年用量'
                    },
                    {
                        value: 'DigitScale',
                        label: this.$t('getapi[165]')//'圆整率'
                    },
                    {
                        value: 'QC_Leadtime',
                        label: this.$t('getapi[6006]')//'质检天数'
                    },
                    {
                        value: 'So_Issue_control',
                        label: this.$t('getapi[6007]')//'控制发料'
                    },
                    {
                        value: 'safe_days',
                        label: this.$t('getapi[6008]')//'取值天数'
                    },
                    {
                        value: 'STOCK_LOWEST',
                        label: this.$t('getapi[6009]')//'订购点'
                    },
                    {
                        value: 'Method',
                        label: this.$t('getapi[6419]')//'计算方法'
                    },
                    {
                        value: 'Routing_Sequence',
                        label: this.$t('getapi[2326]')//'工序'
                    },
                    {
                        value: 'MP_Flag',
                        label: this.$t('getapi[134]')//'物料类别'
                    },
                    {
                        value: 'mrp_fa_flag',
                        label: this.$t('getapi[12583]')//'成品不需要FA'
                    },
                    {
                        value: 'prefix',
                        label: this.$t('getapi[6052]')//'前缀'
                    },
                    {
                        value: 'suffix',
                        label: this.$t('getapi[7127]')//'后缀'
                    },
                    {
                        value: 'digit',
                        label: this.$t('getapi[12579]')//'位数'
                    },
                    {
                        value: 'leadtime_manflag',
                        label: this.$t('getapi[8059]')//'人工提前期'
                    },
                    {
                        value: 'print_flag',
                        label: this.$t('getapi[12720]')//'打印材质'
                    },
                    {
                        value: 'cus_draw_version',
                        label: this.$t('getapi[12962]')//'WT图纸版本'
                    },
                    {
                        value: 'cusitem_name',
                        label: this.$t('getapi[12963]')//'客户项目名称'
                    }
                ],
                planning_CODE: [
                    {
                        value: 'MRP',
                        label: 'MRP'
                    },
                    {
                        value: '人工',
                        label: this.$t('getapi[8624]')//'人工'
                    },
                    {
                        value: '订购点',
                        label: this.$t('getapi[6009]')//'订购点'
                    },
                    {
                        value: 'VMI',
                        label: 'VMI'
                    },
                    {
                        value: 'MPS',
                        label: 'MPS'
                    },
                    {
                        value: '客户供应',
                        label: this.$t('getapi[884]')//'客户供应'
                    }
                ],                
                mp_flag: [
                    {
                        value: '采购',
                        label: this.$t('getapi[235]')//'采购'
                    },
                    {
                        value: '自制',
                        label: this.$t('getapi[242]')//'自制'
                    }
                ],
                saledemandflag: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                So_Issue_control: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                leadtime_manflag: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                printflagarr: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Eng/Parts/PlanImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6011]"),this.$t("getapi[18]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            getitembom(data) {
                let that = this;
                console.log(data)
                if(data.length>0){
                    let arr = []
                    let str = ""
                    let ids = ''
                    if(data.length > 0){
                        for (let i = 0; i < data.length; i++) {
                            arr.push(data[i].exclusively_id);
                        }
                        for (let i = 0; i < arr.length; i++) {
                            str = str + arr[i] + ","
                        }
                        ids = str.substr(0, str.length - 1)
                    }
                    let parm = {
                        PageIndex: 0,
                        PageSize: 0,
                        Param: {
                            Id: 0,
                            Code: ids,
                            Name: '',
                            Where: ''
                        },
                        id: '',
                        name: ''
                    };
                    that.$http.urlpost('/Eng/Parts/GetPartSchedule', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent
                            data = data.filter(item => {
                                return that.dataSet.every(item2 => {
                                    return item.Exclusively_id != item2.Exclusively_id;
                                });
                            });
                            for (let i = 0; i < data.length; i++) {
                                that.dataSet = [...that.dataSet, {
                                    Exclusively_id: data[i].Exclusively_id,
                                    relation_partmaster_id: data[i].relation_partmaster_id,
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    part_status: '',
                                    part_name: '',
                                    planning_CODE: data[i].planning_CODE,
                                    CYCLE_CHECK_INTERVAL: data[i].CYCLE_CHECK_INTERVAL,
                                    LEAST_PURCH_BATCH: data[i].LEAST_PURCH_BATCH.toFixed(4),
                                    MergeDays: data[i].MergeDays,
                                    REQUIRE_PERIOD: data[i].REQUIRE_PERIOD.toFixed(4),
                                    PLANNING_PERIOD: data[i].PLANNING_PERIOD.toFixed(4),
                                    STOCK_UPPERLIMIT: data[i].STOCK_UPPERLIMIT.toFixed(4),
                                    STOCK_LOWERLIMIT: data[i].STOCK_LOWERLIMIT.toFixed(4),
                                    PURCHASE_LEADTIME: data[i].PURCHASE_LEADTIME,
                                    Standard_BATCH: data[i].Standard_BATCH.toFixed(4),
                                    Year_BATCH: data[i].Year_BATCH.toFixed(4),
                                    Produce_LEADTIME: data[i].Produce_LEADTIME,
                                    Is_CYCLE_CHECK: '',
                                    PLANNER_NAME: data[i].Planner_Name,
                                    package_qty: data[i].Package_Qty.toFixed(4),
                                    DigitScale: data[i].DigitScale,
                                    Products: data[i].Products,
                                    saledemandflag: data[i].saledemandflag,
                                    QC_Leadtime: data[i].QC_Leadtime,
                                    So_Issue_control: data[i].so_issue_control,
                                    safe_days: data[i].Safe_days,
                                    STOCK_LOWEST: data[i].STOCK_LOWEST.toFixed(4),
                                    Method: data[i].method,
                                    Routing_Sequence: data[i].routing_sequence,
                                    MP_Flag: data[i].MP_Flag,
                                    DataStatus:data[i].DataStatus,
                                    mrp_fa_flag: data[i].mrp_fa_flag,
                                    prefix: data[i].prefix,
                                    suffix: data[i].suffix,
                                    digit: data[i].digit,
                                    leadtime_manflag: data[i].leadtime_manflag,
                                    print_flag: data[i].print_flag,
                                    cus_draw_version: data[i].cus_draw_version,
                                    cusitem_name: data[i].cusitem_name,
                                }];
                            }
                        }
                    });
                }
            },
            handleSelectionChange({records}) {
                let that = this;
                for (let i = 0; i < records.length; i++) {
                    that.dataChecked.push(records[i].Exclusively_id);
                }
            },
            remove() {
                let that = this;
                let arr = that.dataSet.filter(item => {
                    return that.dataChecked.every(item2 => {
                        return item.Exclusively_id != item2;
                    });
                });
                that.dataSet = arr;
            },
            handleChange(file, fileList) {
                let that = this;
                /*if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.dataSet = file.response.DataContent;
                    }
                }*/
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                that.fileList=[];
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    
                    let data = res.DataContent
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            Exclusively_id: data[i].Exclusively_id,
                            relation_partmaster_id: data[i].relation_partmaster_id,
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            part_status: data[i].part_status,
                            part_name: data[i].part_name,
                            planning_CODE: data[i].planning_CODE,
                            CYCLE_CHECK_INTERVAL: data[i].CYCLE_CHECK_INTERVAL,
                            LEAST_PURCH_BATCH: data[i].LEAST_PURCH_BATCH,
                            MergeDays: data[i].MergeDays,
                            REQUIRE_PERIOD: data[i].REQUIRE_PERIOD,
                            PLANNING_PERIOD: data[i].PLANNING_PERIOD,
                            STOCK_UPPERLIMIT: data[i].STOCK_UPPERLIMIT,
                            STOCK_LOWERLIMIT: data[i].STOCK_LOWERLIMIT,
                            PURCHASE_LEADTIME: data[i].PURCHASE_LEADTIME,
                            Standard_BATCH: data[i].Standard_BATCH,
                            Year_BATCH: data[i].Year_BATCH,
                            Produce_LEADTIME: data[i].Produce_LEADTIME,
                            Is_CYCLE_CHECK: data[i].Is_CYCLE_CHECK,
                            PLANNER_NAME: data[i].PLANNER_NAME,
                            package_qty: data[i].package_qty,
                            DigitScale: data[i].DigitScale,
                            Products: data[i].products,
                            saledemandflag: data[i].saledemandflag,
                            QC_Leadtime: data[i].QC_Leadtime,
                            So_Issue_control: data[i].So_Issue_control,
                            safe_days: data[i].safe_days,
                            STOCK_LOWEST: data[i].STOCK_LOWEST,
                            Method: data[i].Method,
                            Routing_Sequence: data[i].Routing_Sequence,
                            MP_Flag: data[i].MP_Flag,
                            DataStatus:data[i].DataStatus,
                            mrp_fa_flag:data[i].mrp_fa_flag,
                            prefix: data[i].prefix,
                            suffix: data[i].suffix,
                            digit: data[i].digit,
                            leadtime_manflag: data[i].leadtime_manflag,
                            print_flag: data[i].print_flag,
                            cus_draw_version: data[i].cus_draw_version,
                            cusitem_name:data[i].cusitem_name
                        }]
                    }
                    
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: '',
                    name: that.editPlan
                };
                that.$http.urlpost('/Eng/Parts/PlanUpdate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }
    

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
    
</style>
